import { StoreAction } from '@shared/store/store-action.model';
import { StoreActionError } from '@shared/store/store-action-error.model';

import {
  ForgotPasswordApiPayload,
} from '../models/forgot-password-api.model';
import {
  ForgotPasswordResetApiPayload,
} from '../models/forgot-password-reset-api.model';

const FORGOT_PASSWORD_SCOPE = '[Forgot Password]';
const API_SCOPE = `${ FORGOT_PASSWORD_SCOPE } API`;

export namespace ForgotPasswordActions {

  export class RequestEmail extends StoreAction<ForgotPasswordApiPayload> {
    static override readonly type = `${ API_SCOPE } Request Email`;

    constructor(public override payload: ForgotPasswordApiPayload) {
      super(payload);
    }
  }

  export class RequestEmailSuccess extends StoreAction {
    static override readonly type = `${ API_SCOPE } Request Email Success`;
  }

  export class RequestEmailFailed extends StoreActionError {
    static override readonly type = `${ API_SCOPE } Request Email Failed`;
  }

  export class Reset extends StoreAction<ForgotPasswordResetApiPayload> {
    static override readonly type = `${ API_SCOPE } Reset`;

    constructor(public override payload: ForgotPasswordResetApiPayload) {
      super(payload);
    }
  }

  export class ResetSuccess extends StoreAction {
    static override readonly type = `${ API_SCOPE } Reset Success`;
  }

  export class ResetFailed extends StoreActionError {
    static override readonly type = `${ API_SCOPE } Reset Failed`;
  }

  export class SetToken extends StoreAction<string> {
    static override readonly type = `${ FORGOT_PASSWORD_SCOPE } Set Token`;

    constructor(public override payload: string) {
      super(payload);
    }
  }

  export class ResetLoadedState extends StoreAction {
    static override readonly type = `${ FORGOT_PASSWORD_SCOPE } Reset Loaded State`;
  }

  export class ResetState extends StoreAction {
    static override readonly type = `${ FORGOT_PASSWORD_SCOPE } Reset State`;
  }
}
